import aik from '../../images/hockeyallsvenskan/aik.webp';
import almtuna from '../../images/hockeyallsvenskan/almtuna.webp';
import kalmar from '../../images/hockeyallsvenskan/kalmar.webp';
import karlskoga from '../../images/hockeyallsvenskan/karlskoga.webp';
import leksand from '../../images/hockeyallsvenskan/leksand.webp';
import modo from '../../images/hockeyallsvenskan/modo.webp';
import mora from '../../images/hockeyallsvenskan/mora.webp';
import nybro from '../../images/hockeyallsvenskan/nybro.webp';
import oskarshamn from '../../images/hockeyallsvenskan/oskarshamn.webp';
import ostersund from '../../images/hockeyallsvenskan/ostersund.webp';
import sodertalje from '../../images/hockeyallsvenskan/sodertalje.webp';
import vasteras from '../../images/hockeyallsvenskan/vasteras.webp';
import vimmerby from '../../images/hockeyallsvenskan/vimmerby.webp';
import visby from '../../images/hockeyallsvenskan/visby.webp';
import { Team } from '../../models/fixture';
import { Round } from '../../models/round';
import { themeC } from '../../theme/themehelper';

// Hockeyallsvenskan crests: licensed to DBET only, for the duration of the DBET × Hockeyallsvenskan partnership.
// The map is the rights list: keep it in step with the division each season, and remove the map and the
// hockeyallsvenskan/ assets when the partnership ends.
// Keyed by team name as sent in the round payload, lowercased. Some clubs have two participant rows
// with different names (e.g. "AIK" and "AIK Hockey"); every name is listed.
const hockeyallsvenskanCrestsC: Record<string, string> = {
    'aik': aik,
    'aik hockey': aik,
    'almtuna is': almtuna,
    'bik karlskoga': karlskoga,
    'ik oskarshamn': oskarshamn,
    'oskarshamn': oskarshamn,
    'kalmar hc': kalmar,
    'leksands if': leksand,
    'modo hockey': modo,
    'modo': modo,
    'mora ik': mora,
    'mora hockey': mora,
    'nybro vikings if': nybro,
    'nybro vikings': nybro,
    'östersunds ik': ostersund,
    'södertälje sk': sodertalje,
    'västerås ik': vasteras,
    'västerås ik hockey': vasteras,
    'vimmerby hc': vimmerby,
    'visby roma hk': visby,
    'visby roma': visby,
};

const normaliseTeamName = (name: string) => name.normalize('NFC').trim().toLowerCase();

// Hockey rounds are identified by name (e.g. "Hockey9"). Keeps football clubs that share a name (AIK) crest-free.
// Unlike getShirt(), "winter" is not matched: the Winter product is retired.
const isHockeyRound = (round: Round | undefined) => /hockey/i.test(round?.name ?? '');

export const getDbetClubCrest = (theme: string, team: Team, round: Round | undefined): string | undefined => {
    if (theme !== themeC.Dbet || !isHockeyRound(round)) {
        return undefined;
    }
    // A missing name must not crash the scoreboard (getTeamName tolerates it); it just gets no crest.
    return hockeyallsvenskanCrestsC[normaliseTeamName(team.name ?? '')];
};
